import { render, staticRenderFns } from "./InfoAboutDoc.vue?vue&type=template&id=28172035&scoped=true&"
import script from "./InfoAboutDoc.vue?vue&type=script&lang=js&"
export * from "./InfoAboutDoc.vue?vue&type=script&lang=js&"
import style0 from "./InfoAboutDoc.vue?vue&type=style&index=0&id=28172035&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28172035",
  null
  
)

export default component.exports